const jobsData = [
  {
    id: 1,
    title: "Senior Software Engineer",
    company: "Tech Solutions LLC",
    location: "Dubai, UAE",
    salary: "AED 15,000 - 25,000",
    posted: "2 days ago",
    type: "Full Time",
    description: "We are looking for a skilled Senior Software Engineer with 5+ years of experience in full-stack development to join our dynamic team in Dubai. As a Senior Software Engineer, you will be responsible for designing, developing, and maintaining high-quality software solutions for our clients.",
    responsibilities: [
      "Design, develop, and maintain high-quality software solutions",
      "Write clean, efficient, and well-documented code",
      "Collaborate with cross-functional teams to define, design, and ship new features",
      "Identify and resolve performance bottlenecks and bugs",
      "Participate in code reviews and provide constructive feedback to other developers",
      "Mentor junior developers and help them grow their technical skills",
      "Stay up-to-date with emerging trends and technologies in software development"
    ],
    requirements: [
      "Bachelor's degree in Computer Science, Engineering, or a related field",
      "5+ years of experience in software development",
      "Strong proficiency in JavaScript, TypeScript, and modern frameworks (React, Angular, or Vue)",
      "Experience with backend technologies such as Node.js, Python, or Java",
      "Familiarity with database systems (SQL and NoSQL)",
      "Knowledge of cloud platforms (AWS, Azure, or GCP)",
      "Experience with CI/CD pipelines and DevOps practices",
      "Excellent problem-solving and communication skills",
      "Ability to work independently and in a team environment"
    ],
    benefits: [
      "Competitive salary package (AED 15,000 - 25,000 per month)",
      "Health insurance for you and your family",
      "Annual flight tickets to home country",
      "30 days of paid annual leave",
      "Flexible working hours and remote work options",
      "Professional development opportunities and training",
      "Modern office in Business Bay, Dubai",
      "Team building activities and events"
    ],
    datePosted: "July 15, 2024",
    expirationDate: "August 15, 2024",
    education: "Bachelor's Degree",
    experience: "5+ years",
    gender: "Any",
    companyInfo: {
      name: "Tech Solutions LLC",
      website: "https://www.techsolutions.com",
      phone: "+971 4 400 1234",
      email: "careers@techsolutions.com",
      location: "Business Bay, Dubai, UAE",
      size: "50-100 employees",
      industry: "Information Technology"
    }
  },
  {
    id: 2,
    title: "Frontend Developer",
    company: "Digital Solutions",
    location: "Dubai, UAE",
    salary: "AED 10,000 - 15,000",
    posted: "1 week ago",
    type: "Full Time",
    description: "We are seeking a talented Frontend Developer to join our growing team. You will be responsible for creating responsive and user-friendly web applications using modern JavaScript frameworks.",
    responsibilities: [
      "Develop responsive user interfaces using React, Vue, or Angular",
      "Collaborate with UX/UI designers to implement design specifications",
      "Optimize applications for maximum speed and scalability",
      "Ensure cross-browser compatibility",
      "Write clean, maintainable, and testable code",
      "Participate in code reviews and contribute to team knowledge sharing"
    ],
    requirements: [
      "Bachelor's degree in Computer Science or related field",
      "2+ years of experience in frontend development",
      "Proficiency in JavaScript, HTML5, and CSS3",
      "Experience with modern JavaScript frameworks (React, Vue, or Angular)",
      "Knowledge of CSS preprocessors like Sass or Less",
      "Familiarity with build tools like Webpack or Gulp",
      "Experience with version control systems (Git)"
    ],
    benefits: [
      "Competitive salary (AED 10,000 - 15,000)",
      "Health and dental insurance",
      "Annual performance bonus",
      "Professional development budget",
      "Hybrid work options"
    ],
    datePosted: "July 8, 2024",
    expirationDate: "August 8, 2024",
    education: "Bachelor's Degree",
    experience: "2+ years",
    gender: "Any",
    companyInfo: {
      name: "Digital Solutions",
      website: "https://www.digitalsolutions.com",
      phone: "+971 4 400 5678",
      email: "jobs@digitalsolutions.com",
      location: "DIFC, Dubai, UAE",
      size: "20-50 employees",
      industry: "Web Development"
    }
  },
  {
    id: 3,
    title: "Backend Developer",
    company: "Cloud Systems",
    location: "Dubai, UAE",
    salary: "AED 12,000 - 18,000",
    posted: "3 days ago",
    type: "Full Time",
    description: "Join our backend team to design and implement server-side logic, APIs, and data storage solutions for our cloud-based platform.",
    responsibilities: [
      "Design and implement server-side applications and APIs",
      "Develop and maintain databases and data storage solutions",
      "Ensure the performance, quality, and responsiveness of applications",
      "Collaborate with frontend developers to integrate user-facing elements",
      "Implement security and data protection solutions",
      "Troubleshoot and debug server-side applications"
    ],
    requirements: [
      "Bachelor's degree in Computer Science or related field",
      "3+ years of backend development experience",
      "Proficiency in Node.js, Python, Java, or Go",
      "Experience with SQL and NoSQL databases",
      "Knowledge of RESTful APIs and microservices architecture",
      "Understanding of cloud platforms (AWS, Azure, or GCP)",
      "Experience with containerization technologies (Docker, Kubernetes)"
    ],
    benefits: [
      "Competitive salary (AED 12,000 - 18,000)",
      "Comprehensive health insurance",
      "Stock options program",
      "Home office allowance",
      "Learning and development stipend",
      "25 days annual leave"
    ],
    datePosted: "July 12, 2024",
    expirationDate: "August 12, 2024",
    education: "Bachelor's Degree",
    experience: "3+ years",
    gender: "Any",
    companyInfo: {
      name: "Cloud Systems",
      website: "https://www.cloudsystems.com",
      phone: "+971 4 400 9012",
      email: "careers@cloudsystems.com",
      location: "JLT, Dubai, UAE",
      size: "100-200 employees",
      industry: "Cloud Computing"
    }
  },
  {
    id: 4,
    title: "Full Stack Developer",
    company: "Innovative Tech",
    location: "Abu Dhabi, UAE",
    salary: "AED 14,000 - 20,000",
    posted: "5 days ago",
    type: "Full Time",
    description: "We're looking for a Full Stack Developer who can work on both frontend and backend technologies to build complete web applications from the ground up.",
    responsibilities: [
      "Develop both client-side and server-side applications",
      "Build RESTful APIs and integrate third-party services",
      "Implement automated testing and CI/CD processes",
      "Collaborate with cross-functional teams to define requirements",
      "Maintain and improve existing applications",
      "Participate in code reviews and system design discussions"
    ],
    requirements: [
      "Bachelor's degree in Computer Science or related field",
      "4+ years of full stack development experience",
      "Proficiency in both frontend and backend technologies",
      "Experience with modern JavaScript frameworks (React, Vue, Angular)",
      "Experience with backend technologies (Node.js, Python, Java)",
      "Knowledge of database design and optimization",
      "Familiarity with Agile development methodologies"
    ],
    benefits: [
      "Competitive salary (AED 14,000 - 20,000)",
      "Relocation assistance",
      "End of Service Benefits",
      "Annual flight allowance",
      "Professional development opportunities",
      "Flexible working arrangements"
    ],
    datePosted: "July 10, 2024",
    expirationDate: "August 10, 2024",
    education: "Bachelor's Degree",
    experience: "4+ years",
    gender: "Any",
    companyInfo: {
      name: "Innovative Tech",
      website: "https://www.innovativetech.com",
      phone: "+971 2 400 3456",
      email: "jobs@innovativetech.com",
      location: "Al Reem Island, Abu Dhabi, UAE",
      size: "50-100 employees",
      industry: "Software Development"
    }
  },
  {
    id: 5,
    title: "DevOps Engineer",
    company: "Global Systems Inc",
    location: "Sharjah, UAE",
    salary: "AED 13,000 - 19,000",
    posted: "1 day ago",
    type: "Full Time",
    description: "Join our DevOps team to implement and maintain our cloud infrastructure, CI/CD pipelines, and automation processes. We're looking for an experienced DevOps Engineer to help scale our infrastructure and improve our deployment processes.",
    responsibilities: [
      "Design and implement CI/CD pipelines for our applications",
      "Manage cloud infrastructure on AWS, Azure, or GCP",
      "Implement infrastructure as code using Terraform or CloudFormation",
      "Monitor system performance and troubleshoot issues",
      "Automate deployment and scaling processes",
      "Ensure security compliance across all systems",
      "Collaborate with development teams to optimize application performance"
    ],
    requirements: [
      "Bachelor's degree in Computer Science or related field",
      "3+ years of DevOps or infrastructure experience",
      "Experience with cloud platforms (AWS, Azure, or GCP)",
      "Proficiency with containerization technologies (Docker, Kubernetes)",
      "Knowledge of infrastructure as code tools (Terraform, CloudFormation)",
      "Experience with monitoring and logging tools",
      "Strong scripting skills (Python, Bash, or PowerShell)",
      "Understanding of security best practices"
    ],
    benefits: [
      "Competitive salary (AED 13,000 - 19,000)",
      "Health insurance for employee and family",
      "Annual bonus based on performance",
      "Remote work options",
      "Training and certification support",
      "25 days annual leave"
    ],
    datePosted: "July 16, 2024",
    expirationDate: "August 16, 2024",
    education: "Bachelor's Degree",
    experience: "3+ years",
    gender: "Any",
    companyInfo: {
      name: "Global Systems Inc",
      website: "https://www.globalsystems.com",
      phone: "+971 6 400 7890",
      email: "careers@globalsystems.com",
      location: "Al Qasba, Sharjah, UAE",
      size: "200-500 employees",
      industry: "Information Technology"
    }
  },
  {
    id: 6,
    title: "Marketing Manager",
    company: "Global Marketing Group",
    location: "Abu Dhabi, UAE",
    salary: "AED 10,000 - 15,000",
    posted: "3 days ago",
    type: "Part Time",
    description: "A leading marketing agency is seeking a talented Marketing Manager to develop and implement comprehensive marketing strategies for diverse client portfolios. The ideal candidate will have strong experience in digital marketing, brand management, and campaign execution.",
    responsibilities: [
      "Develop and execute comprehensive marketing strategies",
      "Manage brand development and brand awareness initiatives",
      "Oversee digital marketing campaigns across multiple channels",
      "Analyze market trends and consumer behavior",
      "Coordinate with sales teams and external agencies",
      "Monitor campaign performance and ROI",
      "Manage marketing budget allocation and expenses"
    ],
    requirements: [
      "Bachelor's degree in Marketing, Business Administration, or related field",
      "5+ years of marketing experience",
      "Proven track record of successful marketing campaigns",
      "Strong knowledge of digital marketing tools and platforms",
      "Experience with social media marketing and SEO",
      "Excellent communication and presentation skills",
      "Creative thinking and problem-solving abilities",
      "Familiarity with analytics tools like Google Analytics"
    ],
    benefits: [
      "Competitive salary (AED 10,000 - 15,000)",
      "Flexible working hours",
      "Health insurance coverage",
      "Annual performance bonus",
      "Professional development opportunities",
      "Modern office environment"
    ],
    datePosted: "July 14, 2024",
    expirationDate: "August 14, 2024",
    education: "Bachelor's Degree",
    experience: "5+ years",
    gender: "Any",
    companyInfo: {
      name: "Global Marketing Group",
      website: "https://www.globalmarketing.com",
      phone: "+971 2 400 1122",
      email: "careers@globalmarketing.com",
      location: "Al Reem Island, Abu Dhabi, UAE",
      size: "50-100 employees",
      industry: "Marketing & Advertising"
    }
  },
  {
    id: 7,
    title: "Registered Nurse",
    company: "Emirates Hospital",
    location: "Dubai, UAE",
    salary: "AED 8,000 - 12,000",
    posted: "1 day ago",
    type: "Full Time",
    description: "Emirates Hospital is looking for experienced Registered Nurses to join our growing team. The successful candidate will provide high-quality patient care, maintain medical records, and work collaboratively with healthcare professionals.",
    responsibilities: [
      "Provide direct patient care following medical protocols",
      "Monitor patient vital signs and document changes",
      "Administer medications and treatments as prescribed",
      "Educate patients and families about medical conditions",
      "Collaborate with physicians and other healthcare professionals",
      "Maintain accurate and complete medical records",
      "Ensure compliance with healthcare regulations and standards"
    ],
    requirements: [
      "Bachelor's degree in Nursing or equivalent",
      "Valid nursing license and registration",
      "2+ years of nursing experience",
      "Strong knowledge of nursing care principles and procedures",
      "Excellent communication and empathy skills",
      "Ability to work under pressure and make quick decisions",
      "Physical stamina for long shifts",
      "Proficiency in English and Arabic preferred"
    ],
    benefits: [
      "Competitive salary (AED 8,000 - 12,000)",
      "Comprehensive health insurance",
      "Housing allowance",
      "Annual flight tickets",
      "25 days annual leave",
      "Continuing education support",
      "Career advancement opportunities"
    ],
    datePosted: "July 16, 2024",
    expirationDate: "August 16, 2024",
    education: "Bachelor's Degree",
    experience: "2+ years",
    gender: "Any",
    companyInfo: {
      name: "Emirates Hospital",
      website: "https://www.emiratshospital.com",
      phone: "+971 4 400 3344",
      email: "jobs@emiratshospital.com",
      location: "Jumeirah, Dubai, UAE",
      size: "500-1000 employees",
      industry: "Healthcare"
    }
  },
  {
    id: 8,
    title: "Financial Analyst",
    company: "UAE Investment Bank",
    location: "Dubai, UAE",
    salary: "AED 12,000 - 18,000",
    posted: "5 days ago",
    type: "Full Time",
    description: "We are seeking a detail-oriented Financial Analyst to join our corporate finance team. The ideal candidate will perform financial modeling, analyze market trends, and support investment decisions.",
    responsibilities: [
      "Perform financial modeling and forecasting",
      "Analyze financial statements and investment opportunities",
      "Prepare comprehensive financial reports and presentations",
      "Monitor market trends and economic indicators",
      "Support investment decision-making processes",
      "Conduct risk analysis and valuation assessments",
      "Collaborate with internal teams and external stakeholders"
    ],
    requirements: [
      "Bachelor's degree in Finance, Accounting, or related field",
      "3+ years of financial analysis experience",
      "Strong proficiency in Excel and financial modeling",
      "Knowledge of investment principles and financial markets",
      "Experience with financial analysis software",
      "CFA certification preferred",
      "Strong analytical and critical thinking skills",
      "Excellent attention to detail"
    ],
    benefits: [
      "Competitive salary (AED 12,000 - 18,000)",
      "Performance-based bonuses",
      "Comprehensive health insurance",
      "Retirement plan contributions",
      "Professional certification support",
      "Career development programs"
    ],
    datePosted: "July 12, 2024",
    expirationDate: "August 12, 2024",
    education: "Bachelor's Degree",
    experience: "3+ years",
    gender: "Any",
    companyInfo: {
      name: "UAE Investment Bank",
      website: "https://www.uaebank.com",
      phone: "+971 4 400 5566",
      email: "careers@uaebank.com",
      location: "DIFC, Dubai, UAE",
      size: "1000+ employees",
      industry: "Banking & Finance"
    }
  },
  {
    id: 9,
    title: "Hotel Manager",
    company: "Luxury Resort & Spa",
    location: "Dubai, UAE",
    salary: "AED 20,000 - 30,000",
    posted: "4 days ago",
    type: "Full Time",
    description: "A 5-star luxury resort is looking for an experienced Hotel Manager to oversee daily operations, manage staff, and ensure exceptional guest experiences.",
    responsibilities: [
      "Oversee all hotel operations and daily management",
      "Manage and lead hotel staff across departments",
      "Ensure high-quality guest service and satisfaction",
      "Monitor hotel financial performance and budgets",
      "Implement operational policies and procedures",
      "Coordinate with various departments for seamless operations",
      "Develop strategies to increase revenue and profitability"
    ],
    requirements: [
      "Bachelor's degree in Hotel Management or related field",
      "5+ years of hotel management experience",
      "Previous experience in luxury hospitality",
      "Strong leadership and team management skills",
      "Knowledge of hotel management systems",
      "Excellent guest service orientation",
      "Multilingual capabilities preferred",
      "Understanding of hospitality industry trends"
    ],
    benefits: [
      "Competitive salary (AED 20,000 - 30,000)",
      "Accommodation or housing allowance",
      "Food allowance",
      "Annual flight tickets",
      "End of service benefits",
      "Professional development opportunities",
      "Access to resort facilities"
    ],
    datePosted: "July 13, 2024",
    expirationDate: "August 13, 2024",
    education: "Bachelor's Degree",
    experience: "5+ years",
    gender: "Any",
    companyInfo: {
      name: "Luxury Resort & Spa",
      website: "https://www.luxuryresort.com",
      phone: "+971 4 400 7788",
      email: "hr@luxuryresort.com",
      location: "Palm Jumeirah, Dubai, UAE",
      size: "500-1000 employees",
      industry: "Hospitality & Tourism"
    }
  },
  {
    id: 10,
    title: "English Teacher",
    company: "International School",
    location: "Sharjah, UAE",
    salary: "AED 8,000 - 14,000",
    posted: "2 days ago",
    type: "Full Time",
    description: "We are looking for a qualified English Teacher to join our prestigious international school. The candidate will be responsible for teaching English to students of various age groups and developing their language skills.",
    responsibilities: [
      "Plan and deliver engaging English lessons",
      "Evaluate and document student progress",
      "Develop curriculum and educational materials",
      "Create a positive and inclusive classroom environment",
      "Collaborate with colleagues and parents",
      "Participate in school events and activities",
      "Implement innovative teaching methods and technologies"
    ],
    requirements: [
      "Bachelor's degree in Education or related field",
      "Valid teaching certification/licensure",
      "2+ years of teaching experience",
      "Strong knowledge of English language and literature",
      "Experience with curriculum development",
      "Excellent classroom management skills",
      "Patience and ability to work with diverse student groups",
      "TEFL/TESOL certification preferred"
    ],
    benefits: [
      "Competitive salary (AED 8,000 - 14,000)",
      "Education allowance for children",
      "Comprehensive health insurance",
      "Housing allowance",
      "Annual flight tickets",
      "Professional development opportunities",
      "Summer vacation"
    ],
    datePosted: "July 15, 2024",
    expirationDate: "August 15, 2024",
    education: "Bachelor's Degree",
    experience: "2+ years",
    gender: "Any",
    companyInfo: {
      name: "International School",
      website: "https://www.intlschool.com",
      phone: "+971 6 400 9900",
      email: "jobs@intlschool.com",
      location: "University City, Sharjah, UAE",
      size: "200-500 employees",
      industry: "Education"
    }
  }
];

export default jobsData;